<template>
  <div :class="$style.gridRoot">
    <div :class="[$style.top, $style.row]">
        <slot name="top" />
    </div>
    <div :class="[$style.middle, $style.row, $style.cell]">
        <slot name="middle" />
    </div>
    <div :class="[$style.bottom, $style.row, $style.cell]">
        <slot name="bottom" />
    </div>
  </div>
</template>

<style module>
.gridRoot {
  height: 20%; /* Use full viewport height */
/*  height: 100%;*/
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.row {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.cell {
  flex: 1;
}

.top {
  align-items: flex-start;
}

.middle {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: stretch;
/*  align-items: center;*/
  margin-right: 20px;
}

.bottom {
  height: 10%;  /* The bottom section will take about 10% of the screen height */
  display: flex;
  align-items: flex-end;
}

</style>
